// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles/global.css
// module id = 1502
// module chunks = 0